import { memoryGridConfig } from '@labrain/engine-staircase';
export const staircaseConfig = {
    ...memoryGridConfig,
    // MVP : on coupe à 16 essais pour rester < 5 min (test live).
    maxTrials: 16,
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, gridSize: 4, mode: 'forward', mentalMapSkin: false, multiModal: false, label: 'Span de base' };
    }
    if (level <= 20) {
        return { level, gridSize: 5, mode: 'forward', mentalMapSkin: false, multiModal: false, label: 'Densité accrue' };
    }
    if (level <= 30) {
        return { level, gridSize: 5, mode: 'backward', mentalMapSkin: false, multiModal: false, label: 'Manipulation inverse' };
    }
    if (level <= 40) {
        return { level, gridSize: 5, mode: 'backward', mentalMapSkin: true, multiModal: false, label: 'Carte mentale' };
    }
    return { level, gridSize: 6, mode: 'backward', mentalMapSkin: true, multiModal: true, label: 'Multi-modal' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durées non-staircase (illumination, ISI, feedback). */
export const timing = {
    /** Affichage grille statique avant séquence */
    preSequenceMs: 1000,
    /** Une case allumée */
    cellLitMs: 600,
    /** Inter-stimulus entre cases */
    isiMs: 200,
    /** Délai avant input "À toi" */
    goSignalMs: 400,
    feedbackMs: 900,
    itiMs: 700,
};
export const paradigmMeta = {
    slug: 'memory-grid',
    paradigm: 'Corsi block-tapping (Corsi 1972)',
    masterMage: 'Ondine (mémoire-eau) + Garek (spatial-terre)',
    category: 'eau_memoire',
    goal: 'Mémoire de séquence visuelle — codes, plans, navigation.',
    caveat: 'Far-transfer Gf REFUTÉ (Melby-Lervåg 2013). On ne promet pas "plus intelligent" — on entraîne le span pour codes & séquences.',
};
//# sourceMappingURL=params.js.map